import React from "react";
import classNames from "classnames";
import style from "./index.module.scss";

interface CourseButtonProps {
    type: "add" | "pick";
    className?: string;
    onClick?: () => void;
    children?: React.ReactNode;
}

export default function CourseButton({
    type,
    className,
    onClick,
    children
}: CourseButtonProps) {
    return (
        <button
            className={classNames(className, style[type])}
            onClick={onClick}>
            {children}
        </button>
    );
}
